/** PlayGame 的網站類型，後端用來記錄注單渠道（Telegram 改由 isTelegram 參數標記） */
export type SiteType = 'PC' | 'Mobile' | 'APP';

/** 是否在 Telegram Mini App 內：沿用啟動時依 ?isTgApp=true（或 initData）寫入的旗標 */
export function isTelegramMiniApp(): boolean {
  return sessionStorage.getItem('isTgApp') === 'true';
}

/** 依優先序決定注單渠道：APP > Mobile > PC（Telegram Mini App 內照實際裝置判斷） */
export function resolveSiteType(ctx: { isNativeApp: boolean; isMobile: boolean }): SiteType {
  if (ctx.isNativeApp) return 'APP';
  return ctx.isMobile ? 'Mobile' : 'PC';
}
